const wowApp = require('angular').module('wowApp.shop');

wowApp.service('InspirationService', ['Restangular', '$rootScope', '$window', require('./inspiration-service')]);

wowApp.directive('wowInspirationNavigation', ['InspirationService', '$timeout', '$location', '$anchorScroll', '$state', '$rootScope', 'BreakpointsService', 'FeatureService', require('./inspiration-navigation-directive')]);
wowApp.directive('wowInspirationNavigationV2', ['InspirationService', '$location', require('./inspiration-navigation-directive-v2')]);

wowApp.directive('wowInspirationCard', ['$state', '$location', 'InspirationService', 'AtmService', '$compile', 'BreakpointsService', require('./inspiration-card-directive')]);

wowApp.directive('bwsFeatureCard', [require('../feature-card/feature-card-directive')]);

wowApp.directive('wowInspirationDetail', ['$timeout', '$location', 'CardDetailService', 'AtmService', 'SmallFormatSizingService', require('./inspiration-detail-directive')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/inspiration/index.js
 **/